"use client";

import { useRouter } from "next/navigation";

interface GoBackNavigationButtonProps {
  children: React.ReactNode;
  className?: string;
}

export function GoBackNavigationButton({
  children,
  className,
}: GoBackNavigationButtonProps) {
  const router = useRouter();

  function handleBack() {
    if (typeof window !== "undefined" && window.history.length > 1) {
      router.back();
      return;
    }
    router.replace("/");
  }

  return (
    <button type="button" onClick={handleBack} className={className}>
      {children}
    </button>
  );
}
